export default "__VITE_ASSET__DshiWh88__"